<!-- 业务商品调税操作 -->
<template>
  <div>
    <div v-if="isLoaded">
      <div class="demo-drawer__content data_action_form">
        <div class="page_title">
          <el-alert :title="dataActionBox.boxTitle" type="success" effect="dark" :closable="false">
          </el-alert>
        </div>
        <el-tabs type="border-card" v-model="showTabs" class="el-tabs--border-card_new">
          <el-tab-pane label="调税信息表单">
            <div class="table_content_box">
              <!-- 主要信息 -->
              <el-form label-width="150px" class="baseForm" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                <el-row ref="mainForm">
                  <el-form-item label="税务分类名称" prop="taxname">
                    <el-select v-model="sendDataInfo.taxname" @change="taxChange">
                      <el-option v-for="(dictionariesValue,dictionariesKey) in dictionariesData.swflmc" :key="dictionariesKey" :label="dictionariesValue.diName" :value="dictionariesValue.diValue">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="税务分类编码" prop="taxnumber" :rules="[{required: true,  trigger: ['blur', 'change']}]">
                    <el-input v-model="sendDataInfo.taxnumber" :maxlength="$store.state.inputLength" :disabled="sendDataInfo.taxname != ''"></el-input>
                  </el-form-item>
                  <el-form-item label="进项税率" prop="inRate" :rules="[{required: true,  trigger: ['blur', 'change']}]">
                    <el-select v-model="sendDataInfo.inRate">
                      <el-option v-for="(dictionariesValue,dictionariesKey) in JSON.parse(inRatelist)" :key="dictionariesKey" :label="dictionariesValue.key" :value="dictionariesValue.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="销项税率" prop="outRate" :rules="[{required: true,  trigger: ['blur', 'change']}]">
                    <el-select v-model="sendDataInfo.outRate">
                      <el-option v-for="(dictionariesValue,dictionariesKey) in JSON.parse(inRatelist)" :key="dictionariesKey" :label="dictionariesValue.key" :value="dictionariesValue.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-row>
                <el-row ref="mainForm" v-if="dataActionBox.actionType == 2">
                  <el-form-item v-if="formOneValue.isShow==1" :label="formOneValue.showField+':'" v-for="(formOneValue,formOneKey) in formListValue.jurconfigform" :key="formOneKey" :prop="formOneValue.entityField" :rules="formOneValue.isRequired == 1 ? [{required: true,  trigger: ['blur', 'change']}] : []">
                    <span v-if="formOneValue.isRift == 1">
                      <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{sendDataInfo[formOneValue.entityField]}}</a>
                    </span>
                    <span v-else-if="formOneValue.entityField == 'purmSdate'">
                        {{ $common.getLocalTime(sendDataInfo[formOneValue.entityField]) }}
                    </span>
                    <span v-else-if="formOneValue.entityField == 'taxnumber'">{{sendDataInfo.smName}}</span>
                    <span v-else-if="formOneValue.entityField == 'inRate'">{{sendDataInfo.opmName}}</span>
                    <span v-else-if="formOneValue.entityField == 'outRate'">{{sendDataInfo.depName}}</span>
                    <span v-else-if="formOneValue.entityField == 'taxname'">{{sendDataInfo.taxname}}</span>
                    <span v-else>{{sendDataInfo[formOneValue.entityField]}}</span>
                  </el-form-item>
                </el-row>
              </el-form>
            </div>
          </el-tab-pane>
        </el-tabs>

        <div style="margin-top:.2rem;text-align:center;">
          <el-button v-if="dataActionBox.actionType!=2" type="primary" @click="initActionBox('sendDataInfo')">取消</el-button>
          <el-button type="primary" @click="sendDataAction('sendDataInfo')">确定</el-button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  name: 'businessGoodsTax',
  props: ['bgTaxActionData'],
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      inRatelist: "[{\"key\":\"17\",\"value\":\"17\"},{\"key\":\"16\",\"value\":\"16\"},{\"key\":\"13\",\"value\":\"13\"},{\"key\":\"10\",\"value\":\"10\"},{\"key\":\"9\",\"value\":\"9\"},{\"key\":\"6\",\"value\":\"6\"},{\"key\":\"3\",\"value\":\"3\"},{\"key\":\"1\",\"value\":\"1\"},{\"key\":\"0\",\"value\":\"0\"}]",
      outRate: "",
      dataActionBox: {
        showStatus: false,
        openMode: 'ltr' || 'rtl',
        boxTitle: '编辑调税信息',
        actionType: 4,
      },
      sendDataInfo: {
        bgfId: '', //	业务商品财务相关信息Id
        bgmId: '', //	业务商品ID
        goodFinanceReserves1: '', //	预留字段
        goodFinanceReserves2: '', //	预留字段
        goodFinanceReserves3: '', //	预留字段
        goodFinanceReserves4: '', //	预留字段
        goodFinanceReserves5: '', //	预留字段
        goodFinanceReserves6: '', //	预留字段
        inRate: 0, //	进项税率,默认0
        outRate: 0, //	销项税率,默认0
        taxname: '', //	税务分类名称,从字典选择
        taxnumber: '', //	税务分类编码,从字典选择
      },
      showTabs: '',
      dictionariesData: {},
      isLoaded: false,

    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    //下拉获取编码
    taxChange(data) {
      console.log('data', data);
      for (let i = 0; i < this.dictionariesData.swflmc.length; i++) {
        const item = this.dictionariesData.swflmc[i]
        if (item.diName == data) {
          this.sendDataInfo.taxnumber = item.diCode
          break;
        }
      }
    },
    toDetail(orderId) {
      this.$parent.$parent.$parent.toDetail(orderId)
      // this.$emit('toDetail',orderId)
    },

    //确认新增
    sendDataAction(formName1) {
      this.$refs[formName1].validate((valid) => {
        if (valid) {
          this.sub(formName1)
        } else {
          this.$message({
            message: '请完善必填信息',
            type: 'error'
          })
          return false;
        }
      })
    },
    async sub(formName1) {
      var responseData

      responseData = await this.$http.cusinessGoodsTuneTax(this.sendDataInfo)
      if (responseData.status == 200) {
        this.init()
        this.$refs[formName1].resetFields();
        this.$message({
          message: '操作成功',
          type: 'success'
        });
        this.$emit('taxDrawerCancel', true)
      } else {
        this.$message({
          message: responseData.message,
          type: 'error'
        });
      }
    },

    //取消
    initActionBox(formName1) {
      this.$emit('taxDrawerCancel')
      this.init()
      this.$refs[formName1].resetFields();
    },
    //初始化
    init() {
      for (let key in this.sendDataInfo) {
        if (key == 'inRate' || key == "outRate") {
          this.sendDataInfo[key] = 0
        } else {
          this.sendDataInfo[key] = ''
        }
      }
    },
    //父级传入
    openBox(cate, formData, oldData = '') {
      this.showTabs = formData

      this.init()
      if (cate == 4) {
        this.dataActionBox.boxTitle = '编辑信息'
        this.dataActionBox.openMode = 'rtl'
        if (oldData != '') {
          var dataInfo = JSON.parse(JSON.stringify(oldData))
          for (let key in this.sendDataInfo) {
            this.sendDataInfo[key] = dataInfo[key]
          }
        }
      } else {
        this.dataActionBox.boxTitle = '查看信息'
        var dataInfo = JSON.parse(JSON.stringify(oldData))
        for (let key in this.sendDataInfo) {
          this.sendDataInfo[key] = dataInfo[key]
        }
      }
      this.dataActionBox.actionType = cate
      this.dataActionBox.showStatus = true
    },
    // 获取字典数据
    async getPartDictionariesData() {
      let responseData = await this.$http.getPartDictionariesData({
        ids: [14],
      });
      if (responseData.status == 200) {
        this.dictionariesData = responseData.result;
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },

  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.$nextTick(() => {
      var params = this.bgTaxActionData
      this.openBox(params.cate, params.formData, params.oldData)
      this.isLoaded = true
    })
    this.getPartDictionariesData()
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped>
.table_button_box {
  height: 200px;
  background-color: red;
}

.table_content_box {
  overflow-y: auto;
}

.el-row {
  display: flex;
  flex-wrap: wrap;
  padding-right: 20px;
}

.el-drawer {
  outline: none;
}
</style>
